import * as React from 'react';

import { PropertyMap } from '@shared-ui/lodging-property-details';
import { useLocalization } from '@shared-ui/localization-context';

import { SharedUiWrapperProps, withSharedUiPropertyDetails } from './shared-ui-property-details';

interface MapProps extends SharedUiWrapperProps {
  onClose: () => void;
}

const Map: React.FC<MapProps> = ({ inputs, onClose }) => {
  const l10n = useLocalization();

  return (
    <div className="uitk-dialog-layer shared-ui-map" data-stid="infosite-map">
      <PropertyMap inputs={inputs} closeLabel={l10n.formatText('maps.closeButton.label')} onClose={onClose} />
    </div>
  );
};

export const SharedUiMap = withSharedUiPropertyDetails<MapProps>(Map);
SharedUiMap.displayName = 'SharedUiMap';
